import {HeadStateActionTypes} from 'constants/actionType';

const initialState = {
  tipsPickupPosition: {x: '-', y: '-', z: '-'},
  tipsPickupLastCalibrationDate: 'Uncalibrated',
  isTipsPickupRecentlyCalibrated: false,
};

export default function headState(state = initialState, action = '') {
  switch (action.type) {
    case HeadStateActionTypes.SET_TIPS_PICKUP_POSITION:
      return {...state, tipsPickupPosition: action.position};
    case HeadStateActionTypes.SET_TIPS_PICKUP_POSITION_LAST_CALIBRATED_DATE:
      return {...state, tipsPickupLastCalibrationDate: action.date};
    case HeadStateActionTypes.SET_TIPS_PICKUP_IS_RECENTLY_CALIBRATED:
      return {...state, isTipsPickupRecentlyCalibrated: action.isRecentlyCalibrated};
    case HeadStateActionTypes.RESET_STATE:
      return initialState;
    default:
      return state;
  }
}
